export default __webpack_public_path__ + "static/media/bg-smm.8038f413.svg";